import Vue from 'vue';
import App from './App.vue';
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {
    name: 'v-touch'
})

Vue.config.productionTip = false;
export const bus = new Vue({});

Array.prototype.next = function(elem) {
    const index = this.indexOf(elem);
    if (index == (this.length - 1)) {
        return this[0];
    } else {
        const returnIndex = index + 1;
        return this[returnIndex]
    }
}
Array.prototype.previous = function(elem) {
    const index = this.indexOf(elem);
    if (index == 0) {
        const returnIndex = this.length - 1;
        return this[returnIndex];
    } else {
        const returnIndex = index - 1;
        return this[returnIndex]
    }
}
new Vue({
    render: (h) => h(App),
}).$mount('#app');